import { useEffect, useState } from "react";
import { Typography } from "@material-ui/core";
import DialogModal from "../components/UI/DialogModals";
import InstallmentsTable from "../components/shared/Installments/Table";
import InstallmentsPageHeader from "../components/shared/Installments/InstallmentsPageHeader";
import AdvancesForm from "../components/Advances/AdvancesForm";

import { AdvanceStore as Store, AdvanceTableStore } from "../store";
import { lang } from "../i18nLang";

const Advances = () => {
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  useEffect(() => {
    Store.addAdvancesListObserver();

    return () => {
      Store.removeObserver();
    };
  }, []);

  const handleCloseForm = () => setOpen(false);
  const handleCloseDelete = () => setOpenDelete(false);

  const handleClickOpenForm = () => {
    Store.clearCurrentAdvance();
    setOpen(true);
  };

  const handleClickEdit = (id) => {
    Store.setCurrentAdvance(id);
    setOpen(true);
  };

  const handleClickDelete = (id) => {
    Store.setCurrentAdvance(id);
    setOpenDelete(true);
  };

  const handleConfirmDelete = () => {
    Store.deleteAdvance();
  };

  const handleChangeDate = (id, installmentId, newDate) => {
    Store.setCurrentAdvance(id);
    Store.updateInstallmentMaturityDate(installmentId, newDate);
  };

  return (
    <>
      <InstallmentsPageHeader
        title={lang("advances.title")}
        newButtonLabel={lang("advances.new")}
        onNewData={handleClickOpenForm}
        totals={[
          {
            label: lang("advances.balance"),
            value: Store.advancesTotalToBill,
          },
          {
            label: lang("advances.amount"),
            value: Store.advancesTotal,
          },
        ]}
      />
      <InstallmentsTable
        store={AdvanceTableStore}
        onEditRowData={handleClickEdit}
        onDeleteRowData={handleClickDelete}
        onEditMaturityDate={handleChangeDate}
      />
      <AdvancesForm open={open} onClose={handleCloseForm} />
      <DialogModal
        title={lang("advances.deleteModal.title")}
        open={openDelete}
        onClose={handleCloseDelete}
        onConfirm={handleConfirmDelete}
        confirmLabel={lang("delete")}
      >
        <Typography variant="body1">
          {lang("advances.deleteModal.text")}
        </Typography>
      </DialogModal>
    </>
  );
};

export default Advances;
